<template>
  <div class="fixed bg-dark-transparent top-0 bottom-0 left-0 right-0">
    <div class="mt-8 relative mx-6">
      <div class="absolute inline-block right-3" @click="close">
        <close-icon :width="'w-4'" :color="'text-nw-red'"></close-icon>
      </div>
      <textarea
        rows="11"
        class="w-full focus:outline-none pt-8 px-5 text-xs"
        v-model="delivery_note"
        placeholder="Write a note"
      ></textarea>
      <div @click="saveNote">
        <input-button class="text-xs -mt-2">SAVE NOTE</input-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import CloseIcon from '../icons/CloseIcon.vue'
import InputButton from '../inputs/InputButton.vue'
export default {
  props: {
    note: String
  },
  components: { InputButton, CloseIcon },
  data() {
    return {
      delivery_note: null
    }
  },
  methods: {
    saveNote() {
      var note = {
        close: false,
        delivery_note: this.delivery_note
      }
      this.$emit('add-note', note)
    },
    close() {
      if (this.delivery_note != null) {
        Swal.fire({
          title: 'Discard text?',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: `Yes, Discard`
        }).then(result => {
          if (result.isConfirmed) {
            this.delivery_note = null
            this.saveNote()
          }
        })
      } else {
        this.saveNote()
      }
    }
  },
  mounted() {
    this.delivery_note = this.note
  }
}
</script>
